import {
  ON_ERROR,
  CLEAR_ERROR,
  ON_RECEIVE_COUNT,
  ON_RECEIVE_HAS_MORE,
} from './action_types';

const getLocale = () => {
  const lang = navigator.language || navigator.userLanguage;
  if (lang.includes('fr')) {
    return 'fr'
  }
  return 'en'
}

const initialState = {
  error: '',
  count: 0,
  hasMore: false,
  locale: getLocale(),
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ON_ERROR:
      return { ...state, error: payload };
    case CLEAR_ERROR:
      return { ...state, error: '' };
    case ON_RECEIVE_COUNT:
      return { ...state, count: payload };
    case ON_RECEIVE_HAS_MORE:
      return { ...state, hasMore: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app_state/reducers.js